import { isFulfilled } from '@reduxjs/toolkit'

import {
  NodePreloadRulePayload,
  PreloaderRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { INode } from 'common/builder/nodes/nodeInterfaces'
import { fetchUserFields } from 'common/fields/actions/userFieldsActions'

/**
 * Loads user fields data for the Flow Chart.
 * Extracted from CommonRequiredDataNodeGenericPreloaderRule to the separate Preload Rule as
 * userFieldsActions.fetchUserFields is impossible get rejected result of execution in current implementation.
 */
export const CommonUserFieldsNodeGenericPreloadRule: PreloaderRule<INode, NodePreloadRulePayload> =
  {
    predicate: () => true,

    getKey: () => 'common_user_fields',

    createLoader:
      (_, { dispatch }) =>
      async () => {
        const result = await dispatch(fetchUserFields())
        return isFulfilled(result)
      },
  }
